import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';
import { system, variant } from 'styled-system';

const StyledDrawerContainer = styled('div', {
  shouldForwardProp,
})(
  system({
    transitionDuration: true,
  }),
  css({
    position: 'fixed',
    top: 0,
    right: 0,
    'html[dir=rtl] &': {
      right: 'unset',
      left: 0,
    },
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'body',
    bg: 'white',
    zIndex: 'modal',
  }),
  variant({
    prop: 'size',
    variants: {
      large: {
        width: ['80%'],
        maxWidth: '640px',
      },
      full: {
        width: ['100%'],
      },
    },
  }),
  variant({
    prop: 'state',
    variants: {
      opening: {
        opacity: 1,
        transform: 'translateX(100%)',
        transitionTimingFunction: 'ease-in',
        'html[dir=rtl] &': {
          transform: 'translateX(-100%)',
        },
      },
      opened: {
        opacity: 1,
      },
      closing: {
        opacity: 1,
        transform: 'translateX(100%)',
        transitionTimingFunction: 'ease-in',
        'html[dir=rtl] &': {
          transform: 'translateX(-100%)',
        },
      },
      closed: {
        opacity: 0,
      },
    },
  })
);

const DrawerContainer = forwardRef(
  ({ children, size, state, transitionDuration }, ref) => {
    return (
      <StyledDrawerContainer
        size={size}
        state={state}
        transitionDuration={transitionDuration}
        ref={ref}
      >
        {children}
      </StyledDrawerContainer>
    );
  }
);

DrawerContainer.propTypes = {
  children: PropTypes.any.isRequired,
  size: PropTypes.string.isRequired,
  state: PropTypes.oneOf(['opening', 'opened', 'closing', 'closed']).isRequired,
  transitionDuration: PropTypes.string.isRequired,
};

export default DrawerContainer;
